'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

import { NewsCard } from '@/components/NewsCard';
import { StayConnectedSection } from '@/components/StayConnectedSection';
import HexagonalButton from '@/components/bases/HexagonalButton';
import { useGA } from '@/hooks/useGA';
import { useMediumNews } from '@/hooks/useMediumNews';

const POSTS_PER_PAGE = 9;

export default function NewsPage() {
  const router = useRouter();
  const { posts, loading } = useMediumNews();
  const [visibleCount, setVisibleCount] = useState(POSTS_PER_PAGE);
  const { trackButtonClickEvent } = useGA();

  const visiblePosts = posts.slice(0, visibleCount);
  const hasMore = visibleCount < posts.length;

  const handleLoadMore = () => {
    trackButtonClickEvent({ name: 'news_load_more' });
    setVisibleCount(prev => prev + POSTS_PER_PAGE);
  };

  return (
    <div className='bg-[#060912] text-white'>
      <main
        style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}
        className='flex flex-col pt-[120px] md:pt-[180px]'>
        {/* Hero Header */}
        <section className='flex flex-col items-center justify-center px-6'>
          <p className='bg-gradient-to-r from-[#A9A9A9] via-white to-[#A9A9A9] bg-clip-text text-2xl font-bold text-transparent md:text-5xl md:leading-[68px]'>
            LATEST NEWS
          </p>
        </section>

        {/* News Grid Section */}
        <section className='max-w-[1200px] mx-auto w-full px-6 flex flex-col items-center gap-8 py-8 md:gap-8 md:py-14'>
          {loading ? (
            <p className='text-sm text-white/65 md:text-lg'>Loading latest news...</p>
          ) : posts.length === 0 ? (
            <p className='text-sm text-white/65 md:text-lg'>No posts available at this time.</p>
          ) : (
            <>
              {/* Cards Grid */}
              <div className='grid w-full gap-8 md:grid-cols-3 md:gap-10'>
                {visiblePosts.map((post, index) => (
                  <NewsCard
                    key={index}
                    title={post.title}
                    description={post.description}
                    thumbnail={post.thumbnail}
                    onClick={() => {
                      trackButtonClickEvent({ name: 'news_post_click' });
                      router.push(`/news/${index}`);
                    }}
                  />
                ))}
              </div>

              {hasMore && (
                <div className='flex items-center justify-center'>
                  <HexagonalButton width={186} label='LOAD MORE' onClick={handleLoadMore} />
                </div>
              )}
            </>
          )}
        </section>
      </main>

      <StayConnectedSection />
    </div>
  );
}
